import React from 'react';
import ReactDOM from 'react-dom/client';
import type { ProviderIndexProps } from '~/pages/Provider/Index/ProviderIndex';
import { ProviderIndex } from '~/pages/Provider/Index/ProviderIndex';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: ProviderIndexProps;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const data = (window as unknown as WindowWithData).data || {};

root.render(
  <React.StrictMode>
    <ProviderIndex {...data} />
  </React.StrictMode>
);
